import * as React from 'react';
import { Container } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';

const GlobalContactForm = ({ country , brand , locale , headerRichText , footerRichText  })=>{
    const { featureConfigs  } = useFeatureToggles();
    const { globalContactFormUrl  } = featureConfigs;
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("script", {
        src: `${globalContactFormUrl}/main.js`,
        type: "module"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "lxl-contact-form"
    }, /*#__PURE__*/ React.createElement("lxl-app-contact-form", {
        country: country,
        brand: brand,
        locale: locale
    }, /*#__PURE__*/ React.createElement("h3", {
        header: "header"
    }, headerRichText), /*#__PURE__*/ React.createElement("footer", {
        footer: "footer"
    }, footerRichText))));
};

export { GlobalContactForm as default };
//# sourceMappingURL=GlobalContactForm.js.map
